import { FC } from 'react';
import styled from 'styled-components';
import { Avatar } from '../Avatar/Avatar';
import { Icon } from '../Icon/Icon';

const AvatarWrapper = styled.span`
  margin-right: 16px;
`;

const DropdownText = styled.button`
  background-color: transparent;
  border: 0;
  padding: 0;
  color: ${({ theme }) => theme.vars.newColor.blue2};
  cursor: pointer;
  font-weight: 600;

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  svg {
    margin-left: 12px;
    color: ${({ theme }) => theme.vars.newColor.darkGS1};
  }

  :hover {
    color: ${props => props.theme.vars.newColor.blue3};
  }
`;

interface IDropdownTriggerProps {
  /** Label for the dropdown menu. Required. */
  label: string;
  /** aria-label for the dropdown menu. Required. */
  ariaLabel: string;
  /** icon type if dropdown has icon. Off if not set. */
  icon?: string;
  /** icon background color if dropdown has icon. Off if not set.  */
  iconBackground?: string;
  /** Disabled the trigger. Defaults to false */
  disabled?: boolean;
  /** Invoked on click */
  onClick?: (e?: any) => void;
}

export const DropdownTrigger: FC<IDropdownTriggerProps> = props => {
  return (
    <>
      {props.icon && props.iconBackground && (
        <AvatarWrapper>
          <Avatar icon={props.icon} bg={props.iconBackground} />
        </AvatarWrapper>
      )}
      <DropdownText
        onClick={props.onClick}
        disabled={props.disabled}
        data-testid="DropdownTrigger"
        aria-label={props.ariaLabel}
      >
        {props.label}
        <Icon icon="angle-down" />
      </DropdownText>
    </>
  );
};
